import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  useContext,
  useMemo,
  createElement,
  createContext,
} from 'react';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z =
  '.eevee-icon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n}\n\n.eevee-icon svg {\n  display: inline-block;\n  height: 1em;\n  width: 1em;\n}\n\n.eevee-icon > * {\n  line-height: 1;\n}\n';
styleInject(css_248z);

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty =
      Object.defineProperty ||
      function (obj, key, desc) {
        obj[key] = desc.value;
      },
    $Symbol = 'function' == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || '@@iterator',
    asyncIteratorSymbol = $Symbol.asyncIterator || '@@asyncIterator',
    toStringTagSymbol = $Symbol.toStringTag || '@@toStringTag';
  function define(obj, key, value) {
    return (
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0,
      }),
      obj[key]
    );
  }
  try {
    define({}, '');
  } catch (err) {
    define = function (obj, key, value) {
      return (obj[key] = value);
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return (
      defineProperty(generator, '_invoke', {
        value: makeInvokeMethod(innerFn, self, context),
      }),
      generator
    );
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: 'normal',
        arg: fn.call(obj, arg),
      };
    } catch (err) {
      return {
        type: 'throw',
        arg: err,
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype &&
    NativeIteratorPrototype !== Op &&
    hasOwn.call(NativeIteratorPrototype, iteratorSymbol) &&
    (IteratorPrototype = NativeIteratorPrototype);
  var Gp = (GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype));
  function defineIteratorMethods(prototype) {
    ['next', 'throw', 'return'].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ('throw' !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && 'object' == typeof value && hasOwn.call(value, '__await')
          ? PromiseImpl.resolve(value.__await).then(
              function (value) {
                invoke('next', value, resolve, reject);
              },
              function (err) {
                invoke('throw', err, resolve, reject);
              }
            )
          : PromiseImpl.resolve(value).then(
              function (unwrapped) {
                (result.value = unwrapped), resolve(result);
              },
              function (error) {
                return invoke('throw', error, resolve, reject);
              }
            );
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, '_invoke', {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return (previousPromise = previousPromise
          ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg)
          : callInvokeWithMethodAndArg());
      },
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = 'suspendedStart';
    return function (method, arg) {
      if ('executing' === state) throw new Error('Generator is already running');
      if ('completed' === state) {
        if ('throw' === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg; ; ) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ('next' === context.method) context.sent = context._sent = context.arg;
        else if ('throw' === context.method) {
          if ('suspendedStart' === state) throw ((state = 'completed'), context.arg);
          context.dispatchException(context.arg);
        } else 'return' === context.method && context.abrupt('return', context.arg);
        state = 'executing';
        var record = tryCatch(innerFn, self, context);
        if ('normal' === record.type) {
          if (((state = context.done ? 'completed' : 'suspendedYield'), record.arg === ContinueSentinel)) continue;
          return {
            value: record.arg,
            done: context.done,
          };
        }
        'throw' === record.type && ((state = 'completed'), (context.method = 'throw'), (context.arg = record.arg));
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method)
      return (
        (context.delegate = null),
        ('throw' === methodName &&
          delegate.iterator.return &&
          ((context.method = 'return'),
          (context.arg = undefined),
          maybeInvokeDelegate(delegate, context),
          'throw' === context.method)) ||
          ('return' !== methodName &&
            ((context.method = 'throw'),
            (context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")))),
        ContinueSentinel
      );
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ('throw' === record.type)
      return (context.method = 'throw'), (context.arg = record.arg), (context.delegate = null), ContinueSentinel;
    var info = record.arg;
    return info
      ? info.done
        ? ((context[delegate.resultName] = info.value),
          (context.next = delegate.nextLoc),
          'return' !== context.method && ((context.method = 'next'), (context.arg = undefined)),
          (context.delegate = null),
          ContinueSentinel)
        : info
      : ((context.method = 'throw'),
        (context.arg = new TypeError('iterator result is not an object')),
        (context.delegate = null),
        ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0],
    };
    1 in locs && (entry.catchLoc = locs[1]),
      2 in locs && ((entry.finallyLoc = locs[2]), (entry.afterLoc = locs[3])),
      this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    (record.type = 'normal'), delete record.arg, (entry.completion = record);
  }
  function Context(tryLocsList) {
    (this.tryEntries = [
      {
        tryLoc: 'root',
      },
    ]),
      tryLocsList.forEach(pushTryEntry, this),
      this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ('function' == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length; )
              if (hasOwn.call(iterable, i)) return (next.value = iterable[i]), (next.done = !1), next;
            return (next.value = undefined), (next.done = !0), next;
          };
        return (next.next = next);
      }
    }
    return {
      next: doneResult,
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0,
    };
  }
  return (
    (GeneratorFunction.prototype = GeneratorFunctionPrototype),
    defineProperty(Gp, 'constructor', {
      value: GeneratorFunctionPrototype,
      configurable: !0,
    }),
    defineProperty(GeneratorFunctionPrototype, 'constructor', {
      value: GeneratorFunction,
      configurable: !0,
    }),
    (GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, 'GeneratorFunction')),
    (exports.isGeneratorFunction = function (genFun) {
      var ctor = 'function' == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || 'GeneratorFunction' === (ctor.displayName || ctor.name));
    }),
    (exports.mark = function (genFun) {
      return (
        Object.setPrototypeOf
          ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype)
          : ((genFun.__proto__ = GeneratorFunctionPrototype), define(genFun, toStringTagSymbol, 'GeneratorFunction')),
        (genFun.prototype = Object.create(Gp)),
        genFun
      );
    }),
    (exports.awrap = function (arg) {
      return {
        __await: arg,
      };
    }),
    defineIteratorMethods(AsyncIterator.prototype),
    define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }),
    (exports.AsyncIterator = AsyncIterator),
    (exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn)
        ? iter
        : iter.next().then(function (result) {
            return result.done ? result.value : iter.next();
          });
    }),
    defineIteratorMethods(Gp),
    define(Gp, toStringTagSymbol, 'Generator'),
    define(Gp, iteratorSymbol, function () {
      return this;
    }),
    define(Gp, 'toString', function () {
      return '[object Generator]';
    }),
    (exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return (
        keys.reverse(),
        function next() {
          for (; keys.length; ) {
            var key = keys.pop();
            if (key in object) return (next.value = key), (next.done = !1), next;
          }
          return (next.done = !0), next;
        }
      );
    }),
    (exports.values = values),
    (Context.prototype = {
      constructor: Context,
      reset: function (skipTempReset) {
        if (
          ((this.prev = 0),
          (this.next = 0),
          (this.sent = this._sent = undefined),
          (this.done = !1),
          (this.delegate = null),
          (this.method = 'next'),
          (this.arg = undefined),
          this.tryEntries.forEach(resetTryEntry),
          !skipTempReset)
        )
          for (var name in this)
            't' === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      },
      stop: function () {
        this.done = !0;
        var rootRecord = this.tryEntries[0].completion;
        if ('throw' === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function (exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return (
            (record.type = 'throw'),
            (record.arg = exception),
            (context.next = loc),
            caught && ((context.method = 'next'), (context.arg = undefined)),
            !!caught
          );
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ('root' === entry.tryLoc) return handle('end');
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, 'catchLoc'),
              hasFinally = hasOwn.call(entry, 'finallyLoc');
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            } else {
              if (!hasFinally) throw new Error('try statement without catch or finally');
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function (type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, 'finallyLoc') && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry &&
          ('break' === type || 'continue' === type) &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc &&
          (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return (
          (record.type = type),
          (record.arg = arg),
          finallyEntry
            ? ((this.method = 'next'), (this.next = finallyEntry.finallyLoc), ContinueSentinel)
            : this.complete(record)
        );
      },
      complete: function (record, afterLoc) {
        if ('throw' === record.type) throw record.arg;
        return (
          'break' === record.type || 'continue' === record.type
            ? (this.next = record.arg)
            : 'return' === record.type
            ? ((this.rval = this.arg = record.arg), (this.method = 'return'), (this.next = 'end'))
            : 'normal' === record.type && afterLoc && (this.next = afterLoc),
          ContinueSentinel
        );
      },
      finish: function (finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc)
            return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      catch: function (tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ('throw' === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error('illegal catch attempt');
      },
      delegateYield: function (iterable, resultName, nextLoc) {
        return (
          (this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc,
          }),
          'next' === this.method && (this.arg = undefined),
          ContinueSentinel
        );
      },
    }),
    exports
  );
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ['cdnLink', 'defaultSize', 'iconSet', 'defaultColor'],
  _excluded2 = [
    'iconSet',
    'name',
    'title',
    'rotate',
    'color',
    'removeInlineStyle',
    'disableFill',
    'size',
    'SvgComponent',
    'PathComponent',
  ];
var CombinedNameReg = /[+:+]/;
var FETCH_ICON_URL = 'https://eevee-icon.apps-cae.danlu.netease.com/api/getGroupIconByName';
var EeveeIconContext = /*#__PURE__*/ createContext(null);
var FetchData = /*#__PURE__*/ (function () {
  var _ref = /*#__PURE__*/ _asyncToGenerator(
    /*#__PURE__*/ _regeneratorRuntime().mark(function _callee(url) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1)
          switch ((_context.prev = _context.next)) {
            case 0:
              return _context.abrupt(
                'return',
                new Promise(function (resolve, reject) {
                  fetch(url)
                    .then(function (res) {
                      return res.json();
                    })
                    .then(function (result) {
                      return resolve(result);
                    })
                    ['catch'](function (e) {
                      reject(e.toString());
                    });
                })
              );
            case 1:
            case 'end':
              return _context.stop();
          }
      }, _callee);
    })
  );
  return function FetchData(_x) {
    return _ref.apply(this, arguments);
  };
})();
var EeveeIconContextProvider = function EeveeIconContextProvider(props) {
  var cdnLink = props.cdnLink,
    defaultSize = props.defaultSize,
    iconSet = props.iconSet,
    defaultColor = props.defaultColor,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _useState = useState({
      icons: [],
    }),
    remoteIconData = _useState[0],
    setRemoteIconData = _useState[1];
  var storeFetchedIcons = useRef(new Map());
  var getRemoteData = useCallback(
    /*#__PURE__*/ _asyncToGenerator(
      /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
        var iconData;
        return _regeneratorRuntime().wrap(
          function _callee2$(_context2) {
            while (1)
              switch ((_context2.prev = _context2.next)) {
                case 0:
                  if (cdnLink) {
                    _context2.next = 2;
                    break;
                  }
                  return _context2.abrupt('return');
                case 2:
                  _context2.prev = 2;
                  _context2.next = 5;
                  return FetchData(cdnLink);
                case 5:
                  iconData = _context2.sent;
                  setRemoteIconData(iconData);
                  _context2.next = 11;
                  break;
                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2['catch'](2);
                case 11:
                case 'end':
                  return _context2.stop();
              }
          },
          _callee2,
          null,
          [[2, 9]]
        );
      })
    ),
    [cdnLink]
  );
  useEffect(
    function () {
      getRemoteData();
    },
    [getRemoteData]
  );
  return React.createElement(
    EeveeIconContext.Provider,
    Object.assign(
      {
        value: {
          cdnLink: cdnLink,
          iconSet: iconSet,
          defaultColor: defaultColor,
          storeFetchedIcons: storeFetchedIcons,
          remoteIconData: remoteIconData,
          defaultSize: defaultSize,
        },
      },
      restProps
    )
  );
};
// eslint-disable-next-line react-func/max-lines-per-function
var EeveeIcon = function EeveeIcon(_ref3) {
  var iconSet = _ref3.iconSet,
    name = _ref3.name,
    title = _ref3.title,
    rotate = _ref3.rotate,
    color = _ref3.color,
    _ref3$removeInlineSty = _ref3.removeInlineStyle,
    removeInlineStyle = _ref3$removeInlineSty === void 0 ? false : _ref3$removeInlineSty,
    _ref3$disableFill = _ref3.disableFill,
    disableFill = _ref3$disableFill === void 0 ? false : _ref3$disableFill,
    size = _ref3.size,
    SvgComponent = _ref3.SvgComponent,
    PathComponent = _ref3.PathComponent,
    restProps = _objectWithoutPropertiesLoose(_ref3, _excluded2);
  var _ref4 = useContext(EeveeIconContext) || {},
    contextIconSet = _ref4.iconSet,
    cdnLink = _ref4.cdnLink,
    defaultSize = _ref4.defaultSize,
    remoteIconData = _ref4.remoteIconData,
    storeFetchedIcons = _ref4.storeFetchedIcons,
    defaultColor = _ref4.defaultColor;
  var _useState2 = useState(null),
    currentRemoteIcon = _useState2[0],
    setCurrentRemoteIcon = _useState2[1];
  var isCombinedIconName = useMemo(
    function () {
      return CombinedNameReg.test(name);
    },
    [name]
  );
  // 动态获取远程图标
  var getCurrentRemoteIcon = useCallback(
    /*#__PURE__*/ _asyncToGenerator(
      /*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
        var alreadyStoredIcon, _name$split, group, iconName, _yield$FetchData, code, data;
        return _regeneratorRuntime().wrap(
          function _callee3$(_context3) {
            while (1)
              switch ((_context3.prev = _context3.next)) {
                case 0:
                  if (isCombinedIconName) {
                    _context3.next = 2;
                    break;
                  }
                  return _context3.abrupt('return');
                case 2:
                  if (!storeFetchedIcons) {
                    _context3.next = 8;
                    break;
                  }
                  alreadyStoredIcon = storeFetchedIcons.current.get(name);
                  if (!alreadyStoredIcon) {
                    _context3.next = 6;
                    break;
                  }
                  return _context3.abrupt('return', setCurrentRemoteIcon(alreadyStoredIcon));
                case 6:
                  _context3.next = 9;
                  break;
                case 8:
                  console.warn('[Eevee-Icon]:请在组件外包裹ConfigIconProvider，否则将不会缓存当前请求的图标数据');
                case 9:
                  // 请求当前图标数据
                  (_name$split = name.split(':')), (group = _name$split[0]), (iconName = _name$split[1]);
                  _context3.prev = 10;
                  _context3.next = 13;
                  return FetchData(FETCH_ICON_URL + '?group=' + group + '&iconName=' + iconName);
                case 13:
                  _yield$FetchData = _context3.sent;
                  code = _yield$FetchData.code;
                  data = _yield$FetchData.data;
                  if (code === 200) {
                    setCurrentRemoteIcon(data);
                    storeFetchedIcons && storeFetchedIcons.current.set(name, data);
                  }
                  _context3.next = 21;
                  break;
                case 19:
                  _context3.prev = 19;
                  _context3.t0 = _context3['catch'](10);
                case 21:
                case 'end':
                  return _context3.stop();
              }
          },
          _callee3,
          null,
          [[10, 19]]
        );
      })
    ),
    [isCombinedIconName, name]
  );
  useEffect(
    function () {
      getCurrentRemoteIcon();
    },
    [getCurrentRemoteIcon]
  );
  var initialStyle = useMemo(function () {
    return {
      display: 'inline-block',
      stroke: 'currentColor',
      fill: 'currentColor',
    };
  }, []);
  var computedStyle = useMemo(
    function () {
      return _extends(
        {},
        removeInlineStyle ? {} : initialStyle,
        {
          width: size || defaultSize || '1em',
          height: size || defaultSize || '1em',
        },
        rotate
          ? {
              transform: 'rotate(' + rotate + 'deg)',
            }
          : {},
        restProps.style || {}
      );
    },
    [defaultSize, initialStyle, removeInlineStyle, restProps.style, rotate, size]
  );
  var computedWrapperStyle = useMemo(
    function () {
      var hasSetSize = size || defaultSize;
      return _extends(
        {},
        hasSetSize
          ? {
              fontSize: hasSetSize + 'px',
            }
          : {}
      );
    },
    [defaultSize, size]
  );
  var currentIcon = useMemo(
    function () {
      var _ref6, _ref6$icons;
      return isCombinedIconName
        ? currentRemoteIcon
        : (_ref6 = iconSet || contextIconSet || remoteIconData) == null
        ? void 0
        : (_ref6$icons = _ref6.icons) == null
        ? void 0
        : _ref6$icons.find(function (item) {
            return item.properties.name === name;
          });
    },
    [isCombinedIconName, currentRemoteIcon, iconSet, contextIconSet, remoteIconData, name]
  );
  var viewBox = useMemo(
    function () {
      if (currentIcon) {
        var _currentIcon$icon$wid = currentIcon.icon.width,
          width = _currentIcon$icon$wid === void 0 ? '1024' : _currentIcon$icon$wid;
        return '0 0 ' + width + ' 1024';
      } else {
        return null;
      }
    },
    [currentIcon]
  );
  var children = useMemo(
    function () {
      return !!currentIcon
        ? currentIcon.icon.paths.map(function (path, index) {
            var _currentIcon$icon$att;
            var attrs =
              (_currentIcon$icon$att = currentIcon.icon.attrs) == null ? void 0 : _currentIcon$icon$att[index];
            var hasSetFillColor = color || defaultColor;
            var pathProps = _extends(
              {
                d: path,
                key: name + index,
              },
              hasSetFillColor
                ? {
                    fill: hasSetFillColor,
                  }
                : {},
              !disableFill && attrs ? attrs : {}
            );
            return createElement(PathComponent || 'path', pathProps);
          })
        : [];
    },
    [PathComponent, color, defaultColor, currentIcon, disableFill, name]
  );
  if (!(name || iconSet || cdnLink)) return null;
  if (!currentIcon) return null;
  title &&
    children.push(
      createElement(
        'title',
        {
          key: title,
        },
        title
      )
    );
  return React.createElement(
    'span',
    {
      style: computedWrapperStyle,
      className: 'eevee-icon',
    },
    createElement(
      SvgComponent || 'svg',
      _extends({}, restProps, {
        viewBox: viewBox,
        style: computedStyle,
      }),
      children
    )
  );
};

export { EeveeIconContextProvider as ConfigIconProvider, EeveeIcon as Icon };
//# sourceMappingURL=eevee-icon.esm.js.map
